import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import {
    CategoriesListItemOverride,
    CategoriesListResponse,
    CategoryModifierGroupResponse,
    CategoryModifierResponse,
    CategoryOptionGroupResponse,
} from "../../../graphql/types"

// These lists cross-reference each other, so changing one record makes the copies held by the
// others stale. A mutation declares what it invalidated; see ./invalidation-epics.ts for the map.
export type MenuDataEntity = "itemsList" | "itemDetails" | "optionGroups" | "modifierGroups" | "modifiers"

export const MENU_DATA_INVALIDATED = "itemsCategories/menuDataInvalidated"
export const invalidateMenuData = (entities: MenuDataEntity[]) => ({
    type: MENU_DATA_INVALIDATED,
    payload: {
        entities: entities,
    },
})

export const isMenuDataEntityInvalidated = (action: Record<string, any>, entity: MenuDataEntity): boolean =>
    !!(action.payload?.entities as Maybe<MenuDataEntity[]>)?.includes(entity)

export const shouldRefetchMenuDataEntity = (action: Record<string, any>, entity: MenuDataEntity): boolean =>
    action.type !== MENU_DATA_INVALIDATED || isMenuDataEntityInvalidated(action, entity)

export const ITEMS_CATEGORIES_AGENDA_WILL_MOUNT = "itemsCategories/willMount"
export const createActionItemsAndCategoriesWillMount = () => ({
    type: ITEMS_CATEGORIES_AGENDA_WILL_MOUNT,
})

export const ITEMS_CATEGORIES_AGENDA__OPTION_GROUPS_LOADED = "itemsCategories/optionGroups/loaded"
export const createActionItemsAndCategoriesAgendaOptionGroupsLoaded = (data: CategoryOptionGroupResponse) => ({
    type: ITEMS_CATEGORIES_AGENDA__OPTION_GROUPS_LOADED,
    payload: {
        data: data,
    },
})

export const ITEMS_CATEGORIES_AGENDA__MODIFIERS_LOADED = "itemsCategories/modifiers/loaded"
export const createActionItemsAndCategoriesAgendaModifiersLoaded = (data: CategoryModifierResponse) => ({
    type: ITEMS_CATEGORIES_AGENDA__MODIFIERS_LOADED,
    payload: {
        data: data,
    },
})

export const ITEMS_CATEGORIES_AGENDA__MODIFIER_GROUPS_LOADED = "itemsCategories/modifierGroups/loaded"
export const createActionItemsAndCategoriesAgendaModifierGroupsLoaded = (data: CategoryModifierGroupResponse) => ({
    type: ITEMS_CATEGORIES_AGENDA__MODIFIER_GROUPS_LOADED,
    payload: {
        data: data,
    },
})

export const ITEMS_AND_CATEGORIES_LIST_DATA_LOADED = "ITEMS_AND_CATEGORIES_LIST_DATA_LOADED"
export const itemsAndCategoriesListDataLoaded = (data: CategoriesListResponse, locationId: Maybe<string>) => ({
    type: ITEMS_AND_CATEGORIES_LIST_DATA_LOADED,
    payload: {
        data: data,
        locationId: locationId,
    },
})

export const ITEMS_AND_CATEGORIES_LIST_REQUESTED = "ITEMS_AND_CATEGORIES_LIST_REQUESTED"
export const itemsAndCategoriesListRequested = (locationId: Maybe<string>) => ({
    type: ITEMS_AND_CATEGORIES_LIST_REQUESTED,
    payload: {
        locationId: locationId,
    },
})

export const ITEMS_AND_CATEGORIES_LIST_OVERRIDE_DATA_LOADED = "ITEMS_AND_CATEGORIES_LIST_OVERRIDE_DATA_LOADED"
export const itemsAndCategoriesListOverrideDataLoaded = (
    overrides: CategoriesListItemOverride[],
    locationId: string
) => ({
    type: ITEMS_AND_CATEGORIES_LIST_OVERRIDE_DATA_LOADED,
    payload: {
        overrides: overrides,
        locationId: locationId,
    },
})
